export default __webpack_public_path__ + "static/media/MM Privlo Announcement Final 2014 08 12.48e29acb.pdf";